import { ValueOf } from "app/common/utilities/types"

export type CustomText = {
  bold?: true
  italic?: true
  text: string
  underline?: true
}

type EmptyText = {
  text: string
}

export const BlockTextType = {
  BlockQuote: "block-quote",
  Heading1: "heading1",
  Heading2: "heading2",
  Heading3: "heading3",
  ListItem: "list-item",
  OrderedList: "ordered-list",
  Paragraph: "paragraph",
  UnorderedList: "unordered-list",
} as const

export type BlockTextType = ValueOf<typeof BlockTextType>

type BlockText = { children: CustomText[]; type: BlockTextType }

export type ImageElementType = { caption: string; children: EmptyText[]; id: number; type: "image" }

type ExternalLinkElement = { children: CustomText[]; type: "external-link"; url: string }

type TweetElementType = { children: EmptyText[]; markup: string; type: "tweet" }

export type InstagramElementType = { children: EmptyText[]; markup: string; type: "instagram" }

export type BrandLinkElementType = { children: EmptyText[]; id: number; type: "brand-link" }

export type CustomElement =
  | BlockText
  | BrandLinkElementType
  | ExternalLinkElement
  | ImageElementType
  | InstagramElementType
  | TweetElementType

export const emptyStructuredText = [
  {
    children: [{ text: "" }],
    type: BlockTextType.Paragraph,
  },
]
